import { useContext, useEffect, useState } from "react";
import PageContext from "@/utils/page-context";

export default function useCustomerZone() {

    const pageContext = useContext(PageContext);
    const [customerZone, setCustomerZone] = useState((pageContext as any).customerZone);
    const [tenantZone, setTenantZone] = useState((pageContext as any).tenantZone);

    useEffect(() => {
        setCustomerZone((pageContext as any).customerZone);
        setTenantZone((pageContext as any).tenantZone);
    }, [(pageContext as any).customerZone, (pageContext as any).tenantZone]);

    return [customerZone, tenantZone];
};